import { LoggingService } from '@common/services/utility/logging.service';
import { Action, ActionReducer, ActionReducerMap, MetaReducer } from '@ngrx/store';
import { removeSensitiveData, sensitiveTypes, tryStringify } from '@common/helpers/json-helper';

export function log<T>(reducer: ActionReducer<T>): ActionReducer<T> {
  return function (state: T | undefined, action: Action): T {
    try {
      // Sanitize the action before logging to prevent sensitive data leakage
      const sanitizedAction = removeSensitiveData(action, sensitiveTypes);
      LoggingService.logger?.trace(`action: ${tryStringify(sanitizedAction)}`, 'NgRx');
    } catch (error) {
      // Log the error but don't break the Redux flow
      console.error('Error in log meta-reducer:', error);
    }
    // Always call the reducer, even if logging fails
    return reducer(state, action);
  };
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface State {}

export const reducers: ActionReducerMap<State> = {};

export const metaReducers: MetaReducer<State>[] = [log];
